import React from "react";

const NudgeFilterBar = ({ filterList, filteredOpportunities, setFilteredOpportunities, successMessage, loading }) => {

  const toggleFilter = (category) => {
    if(filteredOpportunities.length === filterList.length){
      setFilteredOpportunities([]);
      setFilteredOpportunities(prev =>
        prev.includes(category)
          ? prev.filter(item => item !== category)
          : [...prev, category]
      );
    }else{
      setFilteredOpportunities(prev =>
        prev.includes(category)
          ? prev.filter(item => item !== category)
          : [...prev, category]
      );
    }
  };

  const toggleAll = () => {
    setFilteredOpportunities(prev =>
      prev.length === filterList.length ? [] : filterList
    );
  };

  return (
    <div className="know_whats_tag_block ">
      {!loading && <a
        className={`know_tags ${filteredOpportunities.length === filterList.length ? "active" : ""}`}
        onClick={toggleAll}
      >
        All ({successMessage?.length || 0})
      </a>}
      {filterList.map((filter, index) => {
        const count = successMessage?.filter(item => item.opportunity_category === filter).length || 0;
        return (
          (loading ? (
            <span class="know_tags placeholder col-md-2 bg-secondary"> </span>
          ) : (
            <a
              key={index}
              className={`know_tags ${filteredOpportunities.length !== filterList.length && filteredOpportunities.includes(filter) ? "active" : ""}`}
              onClick={() => toggleFilter(filter)}
            >
              {filter} ({count})
            </a>
          ) )
          
        );
      })}
    </div>
  );
};

export default NudgeFilterBar;
